import mutationsTypes from '@/vuex/autuacao/mutations-types.js'
const types = {
  ...mutationsTypes,
  INICIALIZAR_DADOS: 'INICIALIZAR_DADOS',
  GET_ITENS_GLOSSARIO: 'GET_ITENS_GLOSSARIO',
  GET_LISTA_TIPO_DOCUMENTO: 'GET_LISTA_TIPO_DOCUMENTO',
  GET_LISTA_UNIDADE_PROCEDENCIA: 'GET_LISTA_UNIDADE_PROCEDENCIA',
  GET_LISTA_TIPO_INTERESSADO: 'GET_LISTA_TIPO_INTERESSADO',
  GET_ASSUNTOS: 'GET_ASSUNTOS',
  GET_ASSUNTO: 'GET_ASSUNTO',
  GET_DOCUMENTO_AUTUACAO: 'GET_DOCUMENTO_AUTUACAO',
  GET_LISTA_INTERESSADOS: 'GET_LISTA_INTERESSADOS',
  BUSCAR_LISTA_ASSUNTO: 'BUSCAR_LISTA_ASSUNTO',
  ENVIAR_AUTUACAO: 'ENVIAR_AUTUACAO',
  GET_DOCUMENTO_ORIGEM: 'GET_DOCUMENTO_ORIGEM'
}

export default types



// WEBPACK FOOTER //
// ./src/vuex/autuacao/actions-types.js